import React from 'react';

const ReportarPago = (props) => {
    
    return (
        <div className="product-area">
            <h2>Reportar Pago</h2>
            <div className='row'>
                <div className="col-25">
                    <span className="col-form-span">Banco </span>
                    <select id="Banco" name="Banco" className="form-group"
                        onChange={props.Modificar} value={props.Gestor.Banco}>
                        {props.Gestor.Bancos.map((option, i) => (
                            <option key={i} value={option.CODIGO}>{option.NOMBRE}</option>
                        ))}
                    </select>
                </div>
                <div className="col-25">
                    <span className="col-form-span">Cuenta </span>
                    <select id="Cuenta" name="Cuenta" className="form-group"
                        onChange={props.Modificar} value={props.Gestor.Cuenta}>
                        {props.Gestor.Cuentas.map((option, i) => (
                            <option key={i} value={option.CODIGO}>{option.CUENTA}</option>
                        ))}
                    </select>
                </div>
                <div className="col-25">
                    <span className="col-form-span">Fecha </span>
                    <input type="date" id=" FechaPago" onChange={props.Modificar} name="FechaPago" autoComplete='off'
                        value={props.Gestor.FechaPago}></input>
                </div>
                <div className='col-25'>
                    <span className="col-form-span"># Comprobante </span>
                    <input type="text" id="Comprobante" name="Comprobante" autoComplete='off'
                        value={props.Gestor.Comprobante} onChange={props.Modificar}></input>
                </div>
            </div>

            <div className='row'>
            <div className="col-25">
                    <span className="col-form-span">Actividad para su factura </span>
                    <select id="ActCliente" name="ActCliente" className="form-group"
                        onChange={props.Modificar} value={props.Gestor.ActCliente} > 
                        {props.Gestor.MisActividades.map((option, i) => (
                            <option key={i} value={option.CodigoActividad}>{option.NombreActividad}</option>
                        ))}
                    </select>
                </div>
                <div className="col-25">
                <span className="col-form-span"># Orden </span>
                    <select id="NumOrden" name="NumOrden" className="form-group"
                        onChange={props.Modificar} value={props.Gestor.NumOrden}>
                        {props.Gestor.PagosPendiente.map((option, i) => (
                            <option key={i} value={option.Codigo}>{option.Nombre}</option>
                        ))}
                    </select>
                </div>
                <div className='col-25'>
                    <button disabled={props.Gestor.PagosPendiente.length===0} onClick={ () => props.ReportarPagoPcService() } >Guardar</button>
                </div>
            </div>
        </div>
    );
};

export default ReportarPago;